

const TrustSignals = () => {
  const guarantees = [
    {
      icon: 'ShieldCheckIcon',
      title: 'Money-Back Guarantee',
      description: 'Not satisfied? Get a full refund within 7 days of delivery',
    },
    {
      icon: 'LockClosedIcon',
      title: 'Secure & Confidential',
      description: 'Your footage and content are protected with enterprise-grade security',
    },
    {
      icon: 'ChatBubbleLeftRightIcon',
      title: 'Direct Communication',
      description: 'Chat directly with your editor via Slack or your preferred platform',
    },
    {
      icon: 'DocumentCheckIcon',
      title: 'Transparent Pricing',
      description: 'No hidden fees or surprise charges—what you see is what you pay',
    },
  ];

  return null;
};

export default TrustSignals;